import { render, staticRenderFns } from "./CreateFa.vue?vue&type=template&id=55f5df28&scoped=true"
import script from "./CreateFa.vue?vue&type=script&lang=js"
export * from "./CreateFa.vue?vue&type=script&lang=js"
import style0 from "./CreateFa.vue?vue&type=style&index=0&id=55f5df28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5df28",
  null
  
)

export default component.exports